import type { modulesConfigElem } from "../store/slices/app.slice";

export const mergeFreshModulesPreferringStorage = (
	freshModules: modulesConfigElem[],
	stored: modulesConfigElem[] | null,
): modulesConfigElem[] => {
	if (!stored?.length) return freshModules;
	const byName = new Map(stored.map((m) => [m.moduleName, m]));
	return freshModules.map((fresh) => {
		const st = byName.get(fresh.moduleName);
		if (!st) return fresh;
		return {
			...fresh,
			moduleWeight:
				typeof st.moduleWeight === "number" &&
				Number.isFinite(st.moduleWeight) ?
					st.moduleWeight
				:	fresh.moduleWeight,
			moduleOrder:
				typeof st.moduleOrder === "number" &&
				Number.isFinite(st.moduleOrder) ?
					st.moduleOrder
				:	fresh.moduleOrder,
		};
	});
};
